import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { KomitentKontaktOsoba } from './komitent-kontakt-osoba';

@Component({
  selector: 'yt-komitent-kontakt-osoba',
  templateUrl: './komitent-kontakt-osoba.component.html'
})
export class KomitentKontaktOsobaComponent extends BaseModalContainer<KomitentKontaktOsoba> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentKontaktOsoba>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }
  ngOnInit() {
  }

}
